import React from "react";
import { Outlet } from "react-router-dom";

const LayoutGastos = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default LayoutGastos;
